export default "__VITE_ASSET__MjbqinFJ__"